import axios from "axios";
import { ILoginUserRequestData, ILoginUserResponseData } from "../../types";
import { BASE_API_URL, getAPIHeaderOptions } from "../../utils/apiUtils";

const handleLoginUser = (requestData: ILoginUserRequestData): Promise<ILoginUserResponseData> => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${BASE_API_URL}/auth/login`, requestData, { headers: getAPIHeaderOptions() })
			.then((response) => resolve(response.data))
			.catch((error) => {
				let errorMessage = "Something went wrong";

				if (error && error.response && error.response.data) {
					const errorValue = Object.values(error.response.data)[0];
					errorMessage = errorValue ? String(errorValue) : "Something went wrong";
				}

				reject(errorMessage);
			});
	});
};

const handleLogoutUser = (): Promise<void> => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${BASE_API_URL}/auth/logout`, null, { headers: getAPIHeaderOptions(true) })
			.then(() => resolve())
			.catch((error) => {
				reject(error?.response?.data?.detail);
			});
	});
};

const handleCheckLoginToken = (): Promise<
	"token_valid" | "token_invalid" | "default_password" | "reset_password" | "failed"
> => {
	return new Promise((resolve) => {
		axios
			.get(`${BASE_API_URL}/auth/rbac/users/me/`, { headers: getAPIHeaderOptions(true) })
			.then((response) => {
				if (response.status === 200 && response.data && response.data.username) {
					resolve("token_valid");
					return;
				}

				const errorDetail = response.data && response.data.detail ? String(response.data.detail).toLowerCase() : "";

				if (response.status === 401) {
					if (errorDetail === "invalid token.") {
						resolve("token_invalid");
						return;
					}

					if (errorDetail === "please change default password") {
						resolve("default_password");
						return;
					}
				}

				if (response.status === 403 && errorDetail === "password has expired.") {
					resolve("reset_password");
					return;
				}

				resolve("failed");
			})
			.catch((error) => {
				if (error?.response?.status === 401) resolve("token_invalid");
				else resolve("failed");
			});
	});
};

const authServices = { handleLoginUser, handleLogoutUser, handleCheckLoginToken };

export default authServices;
